import type { TradeInAemVehicleNameType } from "../../../../../tradein/utils/types";
import {
    type TradeInAemExternalDataActions,
    TRADE_IN_AEM_CLEAR_EXT_DATA,
    TRADE_IN_AEM_SET_EXT_DATA,
    TRADE_IN_AEM_SET_EXT_DATA_FAILED,
    TRADE_IN_AEM_SET_INCOMPATIBLE,
    TRADE_IN_AEM_SET_NOTIFICATION,
    TRADE_IN_AEM_SET_SHOW_MODAL,
} from "../actions/TradeInAemExternalDataActions";
import type { TradeInNotificationType } from "../../utils/tradeInAemUtilTypes";

// This is a reducer specifically made to share data from the trade-in aem component to other OR components.
// Current use case is integrated trade-in where Build and USC also implement this reducer in their store and will access trade-in info that way.
export type TradeInAemExternalDataType = {
    vehicleValue: number | null;
    vehicleName: TradeInAemVehicleNameType | null;
    licensePlate: string;
    vin: string;
    quoteId: string;
};
// Added this alias to keep consistency with other OR components.
export type TradeInAemExternalDataReducerType = {
    data: TradeInAemExternalDataType;
    notification: { cash: TradeInNotificationType; monthly: TradeInNotificationType };
    showModal: boolean; // Only used in Apheleia as the Apheleia modals can't be closed with dispatches
    failed: boolean;
    incompatible: boolean;
};

export const tradeInAemExtDataReducerInitialState: TradeInAemExternalDataReducerType = {
    data: { vehicleValue: null, vehicleName: null, licensePlate: "", vin: "", quoteId: "" },
    notification: {
        cash: { show: false, notificationType: null, isError: false },
        monthly: { show: false, notificationType: null, isError: false },
    },
    showModal: false,
    failed: false,
    incompatible: false,
};

const TradeInAemExtDataReducer = (
    state: TradeInAemExternalDataReducerType = tradeInAemExtDataReducerInitialState,
    action: TradeInAemExternalDataActions,
): TradeInAemExternalDataReducerType => {
    switch (action.type) {
        case TRADE_IN_AEM_SET_EXT_DATA: {
            return { ...state, data: action.data };
        }

        case TRADE_IN_AEM_CLEAR_EXT_DATA: {
            return { ...tradeInAemExtDataReducerInitialState };
        }

        case TRADE_IN_AEM_SET_EXT_DATA_FAILED: {
            return { ...state, failed: action.failed };
        }

        case TRADE_IN_AEM_SET_SHOW_MODAL: {
            return { ...state, showModal: action.showModal };
        }

        case TRADE_IN_AEM_SET_INCOMPATIBLE: {
            return { ...state, incompatible: action.incompatible };
        }

        case TRADE_IN_AEM_SET_NOTIFICATION:
            const newConfig = { ...state.notification[action.financeType], show: action.show };
            if (typeof action.notificationType !== "undefined") newConfig.notificationType = action.notificationType;
            if (typeof action.isError !== "undefined") newConfig.isError = action.isError;
            const notification = { ...state.notification, [action.financeType]: newConfig };
            return { ...state, notification };

        default:
            return state;
    }
};

export default TradeInAemExtDataReducer;
